<template>
  <div class="help-details-page">
    <div class="help-details-header">
      <div class="back" @click="goRouter('/help/helpCenter')">
        <a-icon type="left" />
        <span>{{ $t('return') }}</span>
      </div>
      <a-breadcrumb>
        <a-breadcrumb-item>{{$t('helpCenter')}}</a-breadcrumb-item>
        <a-breadcrumb-item>{{ $dt(detail, 'CODE_NAME') }}</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="help-details-content-title-box">
      <img src="../../../public/static/icon/question.svg">
      <span class="help-details-content-title">{{ $dt(detail, 'NOTICE_NAME') }}</span>
    </div>
    <div class="help-details-content-info-box">
      <div v-if="detail.JUMP_URL" class="help-details-content-info-video-box">
        <video :src="$dt(detail, 'JUMP_URL')" class="help-details-content-info-video" controls="">
        </video>
      </div>
      <div class="help-details-content-info">
        <div  class="help-details-content-info-text">
            <div class="ql-editor" v-html="$dt(detail,'CONTENT')"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import helpDetails from "@/views/help/helpDetails";
export default {
  name: "helpDetails",
  components: { helpDetails,},
  data() {
    return {
      detail: {},
      sql:`SELECT N.*,F.FILE_PATH,F.GUID_CODE,F.FILE_TYPE,B.CODE_NAME,B.CODE_NAME_ENG,B.CODE_NAME_RUS FROM GM_NOTICE N LEFT JOIN GM_FILE F ON convert(varchar(50),N.NOTICE_ID) = F.TARGET_ID
            LEFT JOIN BM_BASE_CODE B ON B.CODE_ID = N.NOTICE_CATE
            WHERE N.DEVICE_TYPE LIKE '%20361001%'
            AND N.SYS_TYPE = 20011003
            AND F.TARGET_TYPE = 20071008
            AND F.TARGET_CATE = 20021021
            AND F.STATUS = 1`,
    }
  },
  methods: {
    goRouter(path)
    {
      this.$router.push(path);
    },
    getBulletinData(NOTICE_ID) {
      this.$h5Api({
        type: '1001',
        data: [ this.$dotNetUtil.commonPageJson(this.sql, {NOTICE_ID}, this.pageNumber, this.pageSize, 'NOTICE_ORDER ASC', 2) ],
      }).then(({data}) => {
        this.detail = data?.DATA_LIST?.[0];
      })
    },
  },
  created() {
    if (this.$route.query.NOTICE_ID) {
      this.getBulletinData(this.$route.query.NOTICE_ID);
    }
  }
}
</script>

<style lang="scss">
.help-details-page{
  padding: 24px;
  border-radius: 5px;
  background-color: #FFFFFF;
  .help-details-header{
    display: flex;
    justify-content: space-between;
    .back{
      color: rgba(0, 0, 0, 0.45);
      cursor: pointer;
      :hover{
        color: #1F6CBA;
      }
      .span{
        padding-left: 6px;
      }

    }

    .help-details-icon{
      font-size: 24px;

    }
    .help-details-breadcrumb{

    }
  }
  .help-details-content-title-box{
    margin: 18px 0 0 0;
    padding: 14px 20px;
    background-color: #E5F0FB;
    display: flex;
    align-items: center;
    border-radius: 5px 5px 0 0;

    .help-details-content-title{
      color: #1F6CBA;
      font-size: 18px;
      padding-left: 10px;
    }
  }
  .help-details-content-info-box{
    padding: 24px;
    background-color: #FCFCFC;
    border-radius: 0 0 5px 5px;
    background-position: right bottom;
    background-image: url("../../../public/static/icon/logoBg.png");
    background-repeat: no-repeat;
    background-attachment: scroll;
    .help-details-content-info-video-box{
      display: flex;
      flex-direction: column;
      align-items: center;
      .help-details-content-info-video{
        width: 800px;
        margin-bottom: 16px;
      }
    }
    .help-details-content-info{
      display: flex;
      flex-direction: column;
      align-items: center;
      .help-details-content-info-img{
        margin-bottom: 16px;


      }
      .help-details-content-info-text{
        font-size: 16px;
        color: #8C8C8C;
        margin: 36px;
      }
    }

  }

}
</style>